var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { SummaryCardLabel, SummaryCardShell, SummaryMetricPair, SummaryMetricValue } from '@web/components/layout/SummaryCards/SummaryCards';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { InsightTypeEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
var FILE_SUMMARY_PAIR_METRICS = [
    {
        labelKey: 'driveItemDetails.fileSummary.viewsEdits',
        metricKey: 'viewsEdits',
        leftMetricKey: 'driveItemDetails.fileSummary.views',
        rightMetricKey: 'driveItemDetails.fileSummary.edits'
    },
    {
        labelKey: 'driveItemDetails.fileSummary.commentsSuggestions',
        metricKey: 'commentsSuggestions',
        leftMetricKey: 'driveItemDetails.fileSummary.comments',
        rightMetricKey: 'driveItemDetails.fileSummary.suggestions'
    },
    {
        labelKey: 'driveItemDetails.fileSummary.downloadsPrints',
        metricKey: 'downloadsPrints',
        leftMetricKey: 'driveItemDetails.fileSummary.downloads',
        rightMetricKey: 'driveItemDetails.fileSummary.prints'
    }
];
var buildMetricExportRow = function (t, metricKey, metric) {
    var _a;
    return (_a = {},
        _a[t('driveItemDetails.fileSummary.export.metric')] = metricKey,
        _a[t('driveItemDetails.fileSummary.export.value')] = metric.count,
        _a[t('driveItemDetails.fileSummary.export.diff')] = metric.previous.diffString,
        _a);
};
var buildCsvRows = function (data, t) {
    var pairRows = FILE_SUMMARY_PAIR_METRICS.flatMap(function (_a) {
        var leftMetricKey = _a.leftMetricKey, rightMetricKey = _a.rightMetricKey, metricKey = _a.metricKey;
        var metric = data[metricKey];
        return [
            buildMetricExportRow(t, t(leftMetricKey), metric.left),
            buildMetricExportRow(t, t(rightMetricKey), metric.right)
        ];
    });
    return __spreadArray(__spreadArray([], pairRows, true), [
        buildMetricExportRow(t, t('driveItemDetails.fileSummary.sharingInternal'), data.sharing.internal),
        buildMetricExportRow(t, t('driveItemDetails.fileSummary.sharingExternal'), data.sharing.external),
        buildMetricExportRow(t, t('driveItemDetails.fileSummary.collaborators'), data.collaborators)
    ], false);
};
export var FileSummary = function (_a) {
    var documentId = _a.documentId;
    var t = useTranslation().t;
    var _b = useFilters(), dateFrom = _b.dateFrom, dateTo = _b.dateTo;
    var _c = trpc.documentFileSummary.useQuery({
        documentId: documentId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }, {
        enabled: documentId > 0
    }), data = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('driveItemDetails.fileSummary.title'), description: "widgetTitleDescriptions.itemDetails.driveFileSummary", insightType: InsightTypeEnum.documentFileSummary, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('driveItemDetails.fileSummary.title'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, buildCsvRows(data, t)];
                    }); }); }, disabled: isAiButtonDisabled(data) }) }), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5" }, { children: [FILE_SUMMARY_PAIR_METRICS.map(function (_a) {
                        var labelKey = _a.labelKey, metricKey = _a.metricKey;
                        var metric = data[metricKey];
                        return (_jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t(labelKey) }), _jsx(SummaryMetricPair, { layout: "inline", left: {
                                        value: String(metric.left.count),
                                        diff: metric.left.previous
                                    }, right: {
                                        value: String(metric.right.count),
                                        diff: metric.right.previous
                                    } })] }, metricKey));
                    }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('driveItemDetails.fileSummary.sharing') }), _jsx(SummaryMetricPair, { layout: "inline", left: {
                                    value: String(data.sharing.internal.count),
                                    diff: data.sharing.internal.previous
                                }, right: {
                                    value: String(data.sharing.external.count),
                                    diff: data.sharing.external.previous
                                } })] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('driveItemDetails.fileSummary.collaborators') }), _jsx(SummaryMetricValue, { value: String(data.collaborators.count), diff: data.collaborators.previous })] })] }))] }));
};
